import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { RequestService } from "services/RequestService";

function UpdateForm({ open, onClose, st, onSuccess }) {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    powerStationId: "",
  });

  const [powerStations, setPowerStations] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (st) {
      setFormData({
        id: st.id,
        name: st.name,
        powerStationId: st.powerStationId || "",
      });
    }
  }, [st]);

  useEffect(() => {
    fetchPowerStations();
  }, []);

  const fetchPowerStations = async () => {
    try {
      const response = await RequestService.get("PowerStation");
      if (response.data && !response.data.error) {
        setPowerStations(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching power stations:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when field is modified
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "اسم التوربين مطلوب";
    }
    if (!formData.powerStationId) {
      newErrors.powerStationId = "المحطة مطلوبة";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    onSuccess(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل التوربين البخاري</DialogTitle>
      <DialogContent>
        <MDBox component="form" role="form" onSubmit={handleSubmit} mt={2}>
          <MDBox mb={3}>
            <TextField
              fullWidth
              label="اسم التوربين"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              InputProps={{ style: { height: '45px' } }}
            />
          </MDBox>
          <MDBox mb={3}>
            <FormControl fullWidth error={!!errors.powerStationId}>
              <InputLabel>المحطة</InputLabel>
              <Select
                name="powerStationId"
                value={formData.powerStationId}
                onChange={handleChange}
                label="المحطة"
                sx={{ height: '45px' }}
              >
                {powerStations.map((ps) => (
                  <MenuItem key={ps.id} value={ps.id}>
                    {ps.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </MDBox>
      </DialogContent>
      <DialogActions sx={{ 
            padding: 2, 
            display: 'flex', 
            justifyContent: 'space-between',
            '& > button': {
              marginLeft: '8px',
              marginRight: '0px',
            }
          }}>
        
        <MDButton onClick={handleSubmit} color="info">
          حفظ
        </MDButton>
        <MDButton onClick={onClose} color="secondary">
          إلغاء
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

// PropTypes validation
UpdateForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  st: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    powerStationId: PropTypes.string,
  }),
};

// Default props
UpdateForm.defaultProps = {
  st: null,
};

export default UpdateForm;
